export default {
    props: {
        requestCompletions: {
            type: Object,
            required: false,
            default: () => null,
        },
        requestSearch: {
            type: Object,
            required: false,
            default: () => null,
        },
        tapsCompletions: {
            type: Array,
            default: () => ([]),
        },
        hideResults: {
            type: Boolean,
            default: true,
        },
        hasResults: {
            type: [String, Boolean],
            default: false,
        },
        sortBy: {
            type: String,
            default: '',
        },
        sortDest: {
            type: String,
            default: '',
        },
    },
    computed: {
        filterValues() {
            return this.searchState.public ? this.searchState.public.params || [] : [];
        },
        currencyInOffers() {
            return this.search && this.search.offers ? (this.search.offers[0] || {}).currency : '';
        },
        filterItems() {
            if (this.searchResponse && this.$configuration.sortFilters.length) {
                let sortFilters = this.$configuration.sortFilters;
                let objects = this.searchResponse.params;
                objects.sort((a, b) => {
                    const indexA = sortFilters.indexOf(a.name);
                    const indexB = sortFilters.indexOf(b.name);

                    if (indexA === -1 && indexB === -1) {
                        return 0;
                    } else if (indexA === -1) {
                        return 1;
                    } else if (indexB === -1) {
                        return -1;
                    } else {
                        return indexA - indexB;
                    }
                });
            }
            return this.searchResponse ? this.searchResponse.params || [] : [];
        },
        isResultsVisible() {
            return this.hideResults === false &&
                (this.hasQuery || this.hasResults) && !this.showCompletions &&
                (this.store.state.ui.isFiltersOpened && this.$screen.isMobile) === false;
        },
        searchResponse() {
            return this.requestSearch?.response;
        },
        completionsResponse() {
            return this.requestCompletions ? this.requestCompletions.response : null;
        },
        completionsItems() {
            if (this.completionsResponse) {
                return this.completionsResponse.map(el => Object.assign({ 'active': 0 }, el));
            }
            return [];
        },
        showCompletions() {
            return this.store.state.ui.isCompletionsVisible &&
                (Boolean(this.completionsItems.length) || this.$configuration.skuStrict && this.isSku) && this.isFocused;
        },
        isCompletionsLoading() {
            return this.requestCompletions ? this.requestCompletions.isLoading : false;
        },
        isCompletionsError() {
            return this.requestCompletions ? this.requestCompletions.isError : false;
        },
        errorTextCompletions() {
            return this.requestCompletions ? this.requestCompletions.errorText : null;
        },
    },
};
